import { inRange } from '../../../core/utils/general/general';
import {
  calculateSectionWidthHelper,
  calculateSectionHeightHelper,
} from '../../../sections/utils';
import { WindowSizes } from '../../../windows/constants/windowSizes';
import { SheetDefaults } from '../../constants/sheetDefaults';
import {
  Col,
  EntitySize,
  FilterResults,
  Freeze,
  IRange,
  Row,
  Sheet,
  // Viewport,
  Viewport,
} from '../../types';
import { isIndexWithinRange } from '../area/range';
import {
  createViewportBackward,
  createViewportForward,
  getRowHeaderWidth,
} from '../sheet/uiData';
import { getViewportStartEnd } from '../views/virtualViewport';

export const getDefaultVirtualViewport = (): Viewport => ({
  frozenIndexes: [],
  frozenSizes: [],
  frozenSum: 0,

  nonFrozenIndexes: [0],
  nonFrozenSizes: [],
  nonFrozenSum: 0,
  alternateEntityGroupBarSize: 0,
});

export const getViewportWidth = (
  windowWidth: number,
  sheet: Sheet,
  re: number,
  rowGroupBarWidth: number
) => {
  const groupBarSize = rowGroupBarWidth * sheet.zoom;
  const rowHeaderWidth = getRowHeaderWidth(re, sheet.zoom);
  const right = calculateSectionWidthHelper(sheet.rightSection);
  const left = calculateSectionWidthHelper(sheet.leftSection);

  const width = Math.floor(
    windowWidth -
      groupBarSize -
      rowHeaderWidth -
      SheetDefaults.scrollBarWidth -
      left -
      right
  );

  return width;
};

export const getViewportHeight = (
  windowHeight: number,
  sheet: Sheet,
  groupBarSize: number
) => {
  const dynamictop =
    (groupBarSize + calculateSectionHeightHelper(sheet.dynamicTopSection)) *
    sheet.zoom; // Only dynamic is multiplied by zoom

  const top = calculateSectionHeightHelper(sheet.topSection);
  const bottom = calculateSectionHeightHelper(sheet.bottomSection);

  const height = Math.floor(
    windowHeight -
      WindowSizes.controlBarHeight -
      SheetDefaults.scrollBarHeight -
      SheetDefaults.statusBarHeight -
      dynamictop -
      top -
      bottom
  );

  return height;
};

export const getViewportStart = <T extends Col | Row>(
  // entries: T[],
  entitySizes: EntitySize[],
  hiddenRanges: IRange[],
  viewportSize: number,
  end: number,
  min: number,
  max: number,
  defaultSize: number,
  zoom: number,
  freeze: Freeze,
  filterResults?: FilterResults,
  frozenViewportIndexes?: number[]
) =>
  createViewportBackward(
    min,
    end,
    entitySizes,
    defaultSize,
    max,
    hiddenRanges,
    zoom,
    freeze,
    filterResults,
    viewportSize,
    { useNonFreezeMin: true, frozenViewportIndexes: frozenViewportIndexes }
  );

// export const calculateRowColSize = (
//   defaultSize: number,
//   item: Row | Col,
//   zoom: number
// ) => {
//   if (!item) {
//     return defaultSize * zoom;
//   } else {
//     const size =
//       'height' in item
//         ? item.height ?? defaultSize
//         : (item as Col).width ?? defaultSize;
//     return size * zoom;
//   }
// };

// export const getRowColSize = (
//   defaultSize: number,
//   item: Row | Col,
//   zoom: number
// ) => {
//   if (!item) {
//     return defaultSize * zoom;
//   } else {
//     if (!item) {
//       return defaultSize * zoom;
//     } else if ('height' in item && item.height !== undefined) {
//       return item.height * zoom;
//     } else if ('width' in item && item.width !== undefined) {
//       return item.width * zoom;
//     } else {
//       return defaultSize * zoom;
//     }
//     // const size =
//     //   'height' in item
//     //     ? item.height ?? defaultSize
//     //     : (item as Col).width ?? defaultSize;
//     // return size * zoom;
//   }
// };

export const getEntitySize = (
  entitySizes: EntitySize[],
  index: number,
  defaultSize: number,
  zoom: number
) => {
  for (const entitySize of entitySizes) {
    if (inRange(index, entitySize.start, entitySize.end)) {
      return entitySize.size * zoom;
    }
  }

  return defaultSize * zoom;
};

export const getSizeForViewportIndex = (
  sizes: number[],
  index: number,
  defaultSize: number,
  zoom: number
) => {
  const size = sizes[index];
  if (size !== undefined) return size * zoom;

  return defaultSize * zoom;
};

export const getFreezeBarHandleSize = (freezed: Freeze, zoom: number) =>
  (freezed.frozen ? SheetDefaults.freezeBarHandleSize : 0) * zoom;

export const getViewportEnd = (
  // entries: T[],
  entitySizes: EntitySize[],
  hiddenRanges: IRange[],
  viewportSize: number,
  start: number,
  min: number,
  max: number,
  defaultSize: number,
  zoom: number,
  freeze: Freeze,
  filterResults?: FilterResults,
  frozenViewportIndexes?: number[]
) => {
  const { sum, sizeExceedsMax, indexes, sizes } = createViewportForward(
    start,
    max,
    entitySizes,
    defaultSize,
    hiddenRanges,
    zoom,
    freeze,
    filterResults,
    viewportSize,
    { useNonFreezeMin: true, frozenViewportIndexes: frozenViewportIndexes }
  );

  const { end } = getViewportStartEnd(indexes);

  if (!sizeExceedsMax && end !== undefined) {
    // Adjust "start" to fill the empty space
    return getViewportStart(
      entitySizes,
      hiddenRanges,
      viewportSize,
      end,
      min,
      max,
      defaultSize,
      zoom,
      freeze,
      filterResults
    );
  }
  return {
    sum,
    sizes,
    indexes,
  };
};
